import { render } from "./PillBrowserLink.vue?vue&type=template&id=11c75c7c"
import script from "./PillBrowserLink.vue?vue&type=script&lang=js"
export * from "./PillBrowserLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__